<template>
  <BModal
    id="modal-download-ticket"
    ref="modal-download-ticket"
    hide-footer
    hide-header
    modal-class="modal-dark"
    centered
    no-close-on-backdrop
    no-close-on-esc
    size="xl"
  >
    <div class="text-black text-xl font-semibold text-center mt-2">
      Download Data Tiket
    </div>
    <p class="text-center text-black mt-2">
      Data tiket siap diambil. Yuk pilih data tiket yang ingin kamu respon massal
    </p>
    <template>
      <BContainer class="text-center col text-black mb-2">
        <BRow class="mt-2">
          <BCol
            sm="12"
            md="3"
          >
            <BRow class="border-b-1 bg-[#F4F4F4] p-1 mt-2 mt-md-0 font-semibold">
              Waktu Diupdate
            </BRow>
            <BRow class="my-1 z-10">
              <DateRangePicker
                ref="picker"
                v-model="rangeDate"
                :opens="'rtl'"
                :locale-data="locale"
                :ranges="ranges"
              >
                <template
                  v-slot:input="picker"
                  style="min-width: 350px"
                >
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="mr-1">
                      <span
                        v-if="
                          DAY_MONTH_YEAR(picker.startDate) === DAY_MONTH_YEAR(today)
                        "
                        style="color: #828282 !important"
                      >
                        Hari ini
                      </span>
                      <span
                        v-else-if="
                          DAY_MONTH_YEAR(picker.last2) === DAY_MONTH_YEAR(last2)
                        "
                        style="color: #828282 !important"
                      >
                        Kemarin
                      </span>
                      <span
                        v-else-if="
                          DAY_MONTH_YEAR(picker.startDate) ===
                            DAY_MONTH_YEAR(firstDateOfMonth) &&
                            DAY_MONTH_YEAR(picker.endDate) === DAY_MONTH_YEAR(today)
                        "
                        style="color: #828282 !important"
                      >
                        Bulan ini
                      </span>
                      <span
                        v-else
                        style="color: #828282 !important"
                      >
                        Custom Range
                      </span>
                    </div>
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                      alt="Komerce"
                    >
                  </div>
                </template>
              </DateRangePicker>
            </BRow>
          </BCol>
          <BCol
            sm="12"
            md="3"
          >
            <BRow class="border-b-1 bg-[#F4F4F4] p-1  mt-2 mt-md-0 font-semibold">
              Ekspedisi
            </BRow>
            <div class="p-1">
              <BRow>
                <BFormCheckbox
                  v-model="allSelectedExpedition"
                  class="text-left"
                >
                  <span class="text-black">Pilih semua</span>
                </BFormCheckbox>
              </BRow>
              <BRow
                v-for="(item, idx) in expedition"
                :key="idx"
                class="my-1"
              >
                <BFormCheckbox
                  v-model="selectedExpedition"
                  :value="item.shipping_name"
                  class="text-left"
                >
                  <span class="text-black">{{ item.shipping_name }}</span>
                </BFormCheckbox>
              </BRow>
            </div>
          </BCol>
          <BCol
            sm="12"
            md="3"
          >
            <BRow class="border-b-1 bg-[#F4F4F4] p-1  mt-2 mt-md-0 font-semibold">
              Status Tiket
            </BRow>
            <BRow
              v-for="(item, idx) in statusTicket"
              :key="idx"
              class="my-1"
            >
              <BFormCheckbox
                v-model="selectedStatusTicket"
                :value="item.value"
                class="text-left"
              >
                <span class="text-black">{{ item.label }}</span>
              </BFormCheckbox>
            </BRow>
          </BCol>
          <BCol
            sm="12"
            md="3"
          >
            <BRow class="border-b-1 bg-[#F4F4F4] p-1 mt-2 mt-md-0 font-semibold">
              Jenis Tiket
            </BRow>
            <div class="h-[22rem] overflow-x-hidden p-1">
              <BRow>
                <BFormCheckbox
                  v-model="allSelectedTicketTypeList"
                  class="text-left"
                >
                  <span class="text-black">Pilih semua</span>
                </BFormCheckbox>
              </BRow>
              <BRow
                v-for="(item, idx) in listTicketType"
                :key="idx"
                class="my-1"
              >
                <BFormCheckbox
                  v-model="selectedTicketTypeList"
                  :value="item.id"
                  class="text-left"
                >
                  <span class="text-black">{{ item.name }}</span>
                </BFormCheckbox>
              </BRow>
            </div>
          </BCol>
        </BRow>
      </BContainer>
      <hr>
      <div class="flex items-center justify-between">
        <BCol>
          <div
            v-if="showProgress"
            class="d-flex flex-column"
          >
            <div class="text-[#34A853]">
              Download file
            </div>
            <div class="row w-100 align-items-center">
              <div class="col">
                <b-progress
                  :value="progressValue"
                  max="100"
                  animated
                  variant="success"
                />
              </div>
              <div>
                {{ progressValue }}%
              </div>
            </div>
          </div>
          <div
            v-else
            :class="message === 'Download selesai' ? 'text-[#34A853]' : 'text-[#E31A1A]'"
          >
            {{ message }}
          </div>
        </BCol>
        <BCol>
          <div class="flex justify-end">
            <BButton
              variant="outline-primary"
              class="mr-1"
              @click="closeModal"
            >
              Batal
            </BButton>
            <BButton
              variant="primary"
              :disabled="showProgress"
              @click="onFinish"
            >
              <BSpinner
                v-if="showProgress"
                small
              />
              Download
            </BButton>
          </div>
        </BCol>
      </div>
    </template>
  </BModal>
</template>

<script>
import {
  BModal, BFormCheckbox, BContainer, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  firstDateOfMonth, last2, today,
} from '@/store/helpers'
import { mapState } from 'vuex'
import {
  DAY_MONTH_YEAR, YEAR_MONTH_DAY,
} from '@/libs/formatDate'
import moment from 'moment'
import {
  statusTicket, rangeDate, locale, ranges,
} from './config'

export default {
  components: {
    BModal, BFormCheckbox, BContainer, BRow, BCol, BButton, DateRangePicker, BSpinner,
  },
  data() {
    return {
      showProgress: false,
      progressValue: 0,
      message: '',
      selectedExpedition: [],
      selectedStatusTicket: [],
      selectedTicketTypeList: [],
      statusTicket,
      rangeDate,
      locale,
      ranges,
      firstDateOfMonth,
      last2,
      today,
      DAY_MONTH_YEAR,
    }
  },
  computed: {
    ...mapState('filter', ['expedition', 'listTicketType']),
    allSelectedTicketTypeList: {
      get() {
        return this.listTicketType.length > 0 && this.selectedTicketTypeList.length === this.listTicketType.length
      },
      set(val) {
        this.selectedTicketTypeList = val ? this.listTicketType.map(i => i.id) : []
      },
    },
    allSelectedExpedition: {
      get() {
        return this.expedition.length > 0 && this.selectedExpedition.length === this.expedition.length
      },
      set(val) {
        this.selectedExpedition = val ? this.expedition.map(i => i.shipping_name) : []
      },
    },
  },
  mounted() {
    this.defaultFilter()
  },
  methods: {
    defaultFilter() {
      this.selectedExpedition = this.expedition.map(e => e.shipping_name)
      this.selectedStatusTicket = [0]
      this.selectedTicketTypeList = this.listTicketType.map(e => e.id)
      this.rangeDate = {
        startDate: today,
        endDate: today,
      }
    },
    async onFinish() {
      this.showProgress = true
      this.progressValue = 0
      const interval = setInterval(() => {
        this.progressValue += 1
        if (this.progressValue >= 100) {
          clearInterval(interval)
        }
      })
      const params = {
        start_date: YEAR_MONTH_DAY(this.rangeDate.startDate),
        end_date: YEAR_MONTH_DAY(this.rangeDate.endDate),
        shippings: this.selectedExpedition.join(','),
        ticket_status: this.selectedStatusTicket.join(','),
        type_ticket: this.selectedTicketTypeList.join(','),
      }
      const url = '/komship/api/v1/ticket/partner/export-excel'
      await this.$http_new.get(url, {
        params,
      })
        .then(res => {
          const { data } = res.data
          const a = document.createElement('a')
          a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`
          a.download = `Tiket_Bulk_Komship_${moment().format('DD-MM-YYYY_HH-mm')}.xlsx`
          a.click()
          this.progressValue = 100
          this.showProgress = false
          this.message = 'Download selesai'
          this.closeModal()
        })
        .catch(() => {
          this.progressValue = 0
          this.showProgress = false
          this.message = 'Gagal download'
          this.$toast_error({ message: 'Gagal download data tiket' })
        })
    },
    async closeModal() {
      await this.defaultFilter()
      this.message = ''
      this.$bvModal.hide('modal-download-ticket')
    },
  },
}
</script>
